import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[mcraiModalContent], [mcrai-modal-content], mcrai-modal-content'
})
export class McRAIModalContent {
  @HostBinding('class.mcrai-modal__content') cssClass = true;

  constructor() { }

}
